// components/common/VarianceTooltip.jsx

import { Tooltip } from "primereact/tooltip";
import React, { useId } from "react";

const ValueTooltip = ({
    targetClass='custom-valueTooltip',
    heading='-',
    value1=0,
    value2=0,
    children
}) => {
    const tooltipId = useId().replace(/:/g, "");
    const targetclass = `${targetClass}${tooltipId}`
    // ✅ add tooltip class automatically
    const childWithClass = React.cloneElement(children, {
        className: `${children.props.className || ""} cursor-pointer ${targetclass}`
    });
    return (
        <>
            <Tooltip
                style={{ cursor: "pointer" }}
                className="custom-tooltip-value"
                position="top-0"
                my="bottom-0"
                at="center top"
                target={`.${targetclass}`}
            >
                <h4>
                    {heading}: {value1 ? value1 : '-'} ({value2 ? value2 : '-'})
                </h4>
            </Tooltip>

            {childWithClass}
        </>
    );
};

export default ValueTooltip;
